import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: (): {
    phoneList: any[]
    modalVisible: boolean
    ppVisible: boolean
    slug: string
    slugs: any
    noScroll: boolean
    ipCountryCode: string
    loading: boolean
    disableCVBlock: boolean
    subscribeTag: string
    newsletterTitle: string
    newsletterDescription: string
    newsletterDisclaimer: string
    hideNavigation: boolean
  } => ({
    phoneList: [],
    modalVisible: false,
    ppVisible: false,
    slug: '',
    slugs: {},
    noScroll: false,
    ipCountryCode: '',
    loading: false,
    disableCVBlock: false,
    subscribeTag: 'careers_subscribers',
    newsletterTitle: '',
    newsletterDescription: '',
    newsletterDisclaimer: '',
    hideNavigation: false
  }),
  actions: {
    showModal(value: boolean) {
      this.modalVisible = value
    },
    showPP(value: boolean) {
      this.ppVisible = value
      this.disableScroll(value)
    },
    disableScroll(value: boolean) {
      this.noScroll = value
    }
  }
})
